import { TrashSimple } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { Card, CardBody, CardHeader, CardHeaderTitle, CardMeta } from "@/components/ui/card"
import { CommentTextArea } from "@/modules/patients/detail/health-information/comment-text-area"

interface CommentFormItemProps {
  isEditMode: boolean
  title: string
  dataTestId?: string
  metaData?: string | null
  onDelete: () => void
  commentFieldName: string
}

const CommentFormItem = ({
  isEditMode,
  title,
  dataTestId,
  metaData,
  onDelete,
  commentFieldName,
}: CommentFormItemProps) => {
  return (
    <Card className="flex h-auto flex-col gap-2 p-4 pr-2" data-testid={`${dataTestId}-item`} title={title}>
      <CardHeader data-testid={`${dataTestId}-detail-card-header`} className="items-center gap-4 p-0">
        <div>
          <CardHeaderTitle className="text-base leading-6 font-medium">{title}</CardHeaderTitle>
          <CardMeta data-testid="card-meta">{metaData}</CardMeta>
        </div>
        {isEditMode && (
          <Button
            variant="circle"
            className="h-10 w-10"
            data-testid={`${dataTestId}-delete-card-btn`}
            onClick={onDelete}>
            <TrashSimple className="text-on-surface-subdued" />
          </Button>
        )}
      </CardHeader>
      <CardBody className="pr-2" data-testid={`${dataTestId}-detail-card-body`}>
        <CommentTextArea isEditMode={isEditMode} fieldName={commentFieldName} dataTestId={dataTestId} />
      </CardBody>
    </Card>
  )
}

export { CommentFormItem }
